var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatOffline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  "aria-hidden": "true"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  fillRule: "evenodd",
  d: "M12 16.009A4 4 0 0 1 15.994 12h12.012C30.215 12 32 13.8 32 16.009v7.982A4 4 0 0 1 28.006 28H17.5L12 32V16.009M14 28l2.5-2h11.506c1.1 0 1.994-.9 1.994-2.009V16.01A2.003 2.003 0 0 0 28.006 14H15.994c-1.1 0-1.994.9-1.994 2.009zm3-8c0-.564.436-1 1-1s1 .436 1 1-.436 1-1 1-1-.436-1-1m4 0c0-.564.436-1 1-1s1 .436 1 1-.436 1-1 1-1-.436-1-1m4 0c0-.564.436-1 1-1s1 .436 1 1-.436 1-1 1-1-.436-1-1"
})));
export default SvgChatOffline;